import React, { Context } from "react";
import { DefaultContextValue } from "./types";

const RequestDetailsTemplateContext: Context<DefaultContextValue> = React.createContext({
  request: undefined,
  isBusy: false
} as any);


export default RequestDetailsTemplateContext;